<template>
  <div class="map">
    <form class="finder" v-on:submit.prevent="updateFilter">
      <input id="city" class="input" type="text" placeholder="wpisz miasto" v-model="input.city">
      <select id="voivodeship" class="input" v-model="input.voivodeship">
        <option value="">wybierz województwo</option>
        <option v-for="(voivodeship, key) in voivodeships" :key="key" :value="voivodeship"
                v-text="voivodeship"></option>
      </select>
      <button class="button" type="submit">WYSZUKAJ</button>
    </form>
    <div class="alert" v-html="alert.text"></div>
    <div class="finder-panel">
      <div id="map_canvas"></div>
      <div id="places" ref="places">
        <div>
          <div class="place" v-for="(place, index) in filteredPlaces" :key="index" v-on:click="centerOnMarker(place)">
            <h3 v-text="place.name"></h3>
            <div v-if="place.phone">
              <div class="image-wrapper">
                <img src="../assets/images/phone.svg">
              </div>
              <span v-text="place.phone"></span>
            </div>
            <div v-if="place.website">
              <div class="image-wrapper">
                <img src="../assets/images/globe_icon.svg">
              </div>
              <a class="link" :href="place.website" v-text="place.website"></a>
            </div>
            <div>
              <div class="image-wrapper">
                <img src="../assets/images/map_marker.svg">
              </div>
              <span v-text="place.street + ' ' + place.city"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="infowindow-content">
      <span id="place-name" class="title"></span><br>
      <span id="place-address"></span>
    </div>
  </div>
</template>

<script>
  import markerIcon from '../assets/images/marker.svg'
  import markerActiveIcon from '../assets/images/marker_active.svg'
  import json from '../assets/input.min.json';
  import SimpleBar from 'simplebar'
  const google = window.google;
  export default {
    name: "MapComponent",
    mounted: function () {
      this.simplebar = new SimpleBar(this.$refs.places);
      // Init Map
      const canvas = document.getElementById("map_canvas");
      const options = {
        zoom: 6,
        center: new google.maps.LatLng(52, 19)
      };
      this.map = new google.maps.Map(canvas, options);
      // Init InfoWindow
      this.infowindow = new google.maps.InfoWindow();
      this.infowindowContent = document.getElementById('infowindow-content');
      this.infowindow.setContent(this.infowindowContent);
      // Place Markers
      Object.keys(this.places).map((place) => {
        const position = new google.maps.LatLng(this.places[place].api.location.lat, this.places[place].api.location.lng);
        const marker = new google.maps.Marker({
          position,
          map: this.map,
          title: this.places[place].name.toString(),
          icon: markerIcon
        });
        const _this = this;
        marker.addListener('click', function() {
          _this.centerOnMarker(_this.places[place]);
          _this.filter.active = _this.places[place];
        });
        this.places[place].api.location.marker = marker;
      });
      let bounds = new google.maps.LatLngBounds();
      for (let i = 0; i < this.filteredPlaces.length; i++) {
        bounds.extend(this.filteredPlaces[i].api.location.marker.getPosition());
      }
      this.map.fitBounds(bounds);
    },
    computed: {
      filteredPlaces: function () {
        if(this.filter.active){
          return [this.filter.active];
        }
        if (this.filter.city === null || this.filter.voivodeship === null) {
          return this.places;
        }
        let places = this.places;
        if(this.filter.voivodeship){
          places = places.filter(place => {
            return place.voivodeship === this.filter.voivodeship;
          });
        }
        let placesByVoivodeship = places;
        places = places.filter(place => {
          return place.city.toString().toLowerCase().includes(this.filter.city.toLowerCase());
        });
        let filteredPlaces = places;
        if(filteredPlaces.length < 1 && !this.filter.voivodeship){
          this.updateAlertText("Nie znaleziono punktu w tej miejscowości, podaj województwo by wyszukać inne punkty.");
          return this.places;
        }
        else if(filteredPlaces.length < 1 && this.filter.voivodeship){
          this.updateAlertText("Nie znaleziono punktu w tej miejscowości, zaznaczono punkty w województwie.");
          filteredPlaces = placesByVoivodeship;
        }
        else{
          this.updateAlertText("Znalezione punkty: " + filteredPlaces.length);
        }
        this.places.map(place => {
          place.api.location.marker.setIcon(markerIcon);
        });
        if(filteredPlaces.length < this.places.length){
          filteredPlaces.map(place => {
            place.api.location.marker.setIcon(markerActiveIcon);
          });
        }
        return filteredPlaces;
      }
    },
    data: function () {
      return {
        voivodeships: [
          'dolnośląskie',
          'kujawsko-pomorskie',
          'lubelskie',
          'lubuskie',
          'łódzkie',
          'małopolskie',
          'mazowieckie',
          'opolskie',
          'podkarpackie',
          'podlaskie',
          'pomorskie',
          'śląskie',
          'świętokrzyskie',
          'warmińsko-mazurskie',
          'wielkopolskie',
          'zachodniopomorskie'
        ],
        filter: {
          city: null,
          voivodeship: null,
          active: null
        },
        input: {
          city: '',
          voivodeship: ''
        },
        alert: {
          text: ''
        },
        places: this.placesToArray(),
        map: {},
        simplebar: {}
      }
    },
    methods: {
      updateAlertText(text){
        this.alert.text = text;
      },
      updateFilter: function () {
        this.filter.active = null;
        this.filter.city = this.input.city;
        this.filter.voivodeship = this.input.voivodeship;
        let bounds = new google.maps.LatLngBounds();
        if(this.filteredPlaces.length < 1){
          this.map.setZoom(6);
          this.map.panTo(new google.maps.LatLng(52, 19));
        }
        else{
          for (let i = 0; i < this.filteredPlaces.length; i++) {
            bounds.extend(this.filteredPlaces[i].api.location.marker.getPosition());
          }
          this.map.fitBounds(bounds);
        }
        this.simplebar.getScrollElement().scrollTop = 0;
      },
      placesToArray: function () {
        let placesToArray = [];
        Object.keys(json).map(place => {
          placesToArray[place] = json[place];
        });
        return placesToArray;
      },
      centerOnMarker(place) {
        const marker = place.api.location.marker;
        this.map.setZoom(16);
        this.map.panTo(marker.position);
        this.infowindowContent.children['place-name'].innerHTML = place.name;
        this.infowindowContent.children['place-address'].innerHTML = place.street + " " + place.city;
        this.infowindow.open(this.map, marker);
      }
    }
  }
</script>

<style lang="scss" scoped>
$primary : #000000FF;
$secondary: #B7A364;
$bg-color: #fff;
  .finder-panel{
    display: flex;
    flex-wrap: wrap;
  }
  #map_canvas {
    width: 60%;
    height: 600px;
  }
  #places{
    box-sizing: border-box;
    height: 600px;
    width: 40%;
    padding: 0 20px;
  }
  .place {
    font-family: "Roboto", sans-serif;
    font-size: 14px;
    font-weight: 300;
    line-height: 30px;
    cursor: pointer;
    padding-bottom: 15px;
    border-bottom: 1px solid $primary;
    word-break: break-word;
  }
  .title {
    font-family: Gotham, sans-serif;
    font-weight: bold;
    font-size: 20px;
  }
  #map #infowindow-content {
    display: inline !important;
  }
  .map{
    box-sizing: border-box;
    width: 100%;
    min-height: 800px;
    padding: 50px 10px 0;
  }
  .finder {
    box-sizing: border-box;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  .alert{
    box-sizing: border-box;
    text-align: center;
    font-size: 22px;
    min-height: 44px;
    width: 100%;
    margin-top: 15px;
  }
  .image-wrapper{
    display: inline-block;
    width: 24px;
    height: 30px;
    text-align: center;
    img{
      width: 70%;
      vertical-align: middle;
    }
  }
  .link{
    text-decoration: none;
    color: $primary;
  }
  @media (max-width: 992px) {
    .finder-panel{
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
    }
    #map_canvas {
      order: 2;
      width: 100%;
      height: 300px;
    }
    #places{
      order: 1;
      height: 300px;
      width: 100%;
      margin-bottom: 10px;
    }
    .alert{
      font-size: 18px;
    }
  }
  @media (max-width: 576px) {
    .title {
      font-size: 14px;
    }
    .button, .input{
      width: 100%;
      max-width: 100% !important;
    }
    .finder{
      flex-direction: column;
    }
    .alert{
      font-size: 12px;
    }
  }
</style>
